module.exports = __webpack_public_path__ + "media/images/amenities_icons/apple_tv-4d240f9ba29b7fefa5ed4e72fb26e72b.svg";